import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/utils/i18n';
import { RouteEnum } from '/@/enums/routeEnum';

const recents: AppRouteModule = {
  path: RouteEnum.RECENTS,
  name: RouteEnum.RECENTS,
  component: LAYOUT,
  redirect: RouteEnum.RECENTS_INDEX,
  meta: {
    hideChildrenInMenu: true,
    icon: 'home|svg',
    title: t('routes.recents.recents'),
    orderNo: 0,
  },
  children: [
    {
      path: 'index',
      name: RouteEnum.RECENTS_INDEX,
      component: () => import('/@/views/home/index.vue'),
      meta: {
        title: '',
        // affix: true,
        hideMenu: true,
      },
    },
  ],
};

export default recents;
